import { getDisplayName } from './getDisplayName';
export function wrapDisplayName(Component, hocName) {
  return "".concat(hocName, "(").concat(getDisplayName(Component), ")");
}